import { memo } from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative border-t border-white/10 bg-[#0a0a0c] overflow-hidden"
      data-testid="footer"
    >
      {/* Subtle top glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-px bg-gradient-to-r from-transparent via-[#F47B20]/20 to-transparent" />

      {/* Top section */}
      <div className="px-6 md:px-12 pt-10 pb-6 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-[#F47B20] text-lg">◈</span>
              <span className="font-display font-bold text-lg text-white">AEONEUH</span>
            </div>
            <p className="font-mono text-[11px] text-white/30 leading-relaxed max-w-xs">
              Tactical developer portfolio. Building interfaces
              the way pros pop headshots — deliberately, quickly,
              with obsession for the details.
            </p>
          </div>

          {/* Links */}
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-3">
              [ NAVIGATION ]
            </div>
            <ul className="space-y-2 font-mono text-[11px]">
              {[
                { label: "About", href: "#about" },
                { label: "Loadout", href: "#loadout" },
                { label: "Contact", href: "#contact" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-white/30 hover:text-[#F47B20] transition-colors duration-300">
                    → {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-3">
              [ CHANNELS ]
            </div>
            <ul className="space-y-2 font-mono text-[11px]">
              {[
                { label: "Discord", href: "https://discord.com" },
                { label: "Steam", href: "https://steamcommunity.com/profiles/76561198782390625/" },
                { label: "Instagram", href: "https://www.instagram.com/aeon_dprt/" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-[#F47B20] transition-colors duration-300">
                    ↗ {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5 px-6 md:px-12 py-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 font-mono text-[9px] uppercase tracking-[0.25em] text-white/20">
          <div className="flex items-center gap-3">
            <span>© {year} AEONEUH</span>
            <span className="text-white/10">•</span>
            <span>BUILT WITH REACT + THREE.JS</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400 pulse-dot" />
            <span>ALL SYSTEMS OPERATIONAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default memo(Footer);
